import React, { useState, useEffect } from "react";
import ServicesContent from "./ServicesContent";
import { servicesData } from "../data/servicesData";

const Services = () => {
  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll((prev) => !prev);
  };

  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash.replace('#', '');
      // Check if hash matches any service's title-based ID
      const shouldShowAll = servicesData.some(service => 
        service.title.mainTitle.toLowerCase().replace(/\s+/g, "-") === hash
      );
      
      if (shouldShowAll) {
        setShowAll(true);
        
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    };

    checkHash();

    const handleHashChange = () => {
      checkHash();
    };

    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div id="services">
      {servicesData.slice(0, showAll ? servicesData.length : 2).map((data, index) => (
        <React.Fragment key={data.id}>
          <ServicesContent
            id={data.id}
            title={data.title}
            imageUrl={data.imageUrl}
            heading={data.heading}
            description={data.description}
            keySpecifications={data.keySpecifications}
          />
          {index !== (showAll ? servicesData.length - 1 : 1) && (
            <div className="w-[50vw] h-[2px] bg-pent mx-auto my-8"></div>
          )}
        </React.Fragment>
      ))}

      {servicesData.length > 2 && (
        <div className="flex justify-center mb-8">
          <button
            onClick={toggleShowAll}
            className="px-6 py-3 bg-pri text-white rounded-lg hover:bg-pri-dark transition-colors"
          >
            {showAll ? "Show Less" : "Show All"}
          </button>
        </div>
      )}
    </div>
  );
};

export default Services;